"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = reducer;
const property_1 = require("@genesys/property");
const uom_1 = require("@genesys/uom");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
const Types = __importStar(require("./types"));
const InitialValues = __importStar(require("./initial-values"));
const functions_1 = require("./functions");
const initalState = {
    mode: "calculate",
    coilType: "fluid",
    pvses: [startingPvs("fluid")],
    resultScreen: undefined,
    popupDownloadSelector: undefined
};
function reducer(
// A redux reducer is called with an undefined state to initialise the store, so the
// default has to sit on the first parameter. Making it required, as the rule's fix
// suggests, would leave state undefined on that first call.
// biome-ignore lint/style/useDefaultParameterLast: redux calls this with no state to initialise
state = initalState, action) {
    switch (action.type) {
        case "coil-pro-tool/SET-PROPERTIES-FROM-FILE": {
            // Apply fixes.
            const pvsesFromFile = action.payload.pvses
                .map(applyCalculationOfCoildimensions)
                .map(applyPassesOrCircuitsConsistency)
                .map(applyFinSpacingOrFinsPerInchConsistency);
            // A file carries its own coil type, and anything it does not carry - the coefficients,
            // for one - falls back to that coil type's defaults.
            const coilType = action.payload.coilType;
            pvsesFromFile[0] = property_1.PropertyValueSet.merge(pvsesFromFile[0], startingPvs(coilType));
            return Object.assign(Object.assign({}, state), { coilType: coilType, pvses: pvsesFromFile, resultScreen: undefined });
        }
        case "coil-pro-tool/SET-PROPERTIES": {
            let pvs = action.payload.pvs;
            // The properties selector sends only what changed, so merge over what we already hold.
            pvs = property_1.PropertyValueSet.merge(pvs, state.pvses[0]);
            pvs = applyCalculationOfCoildimensions(pvs);
            pvs = applyPassesOrCircuitsConsistency(pvs);
            pvs = applyFinSpacingOrFinsPerInchConsistency(pvs);
            pvs = applySweepDefaults(pvs, state.coilType);
            return Object.assign(Object.assign({}, state), { pvses: [pvs], resultScreen: undefined });
        }
        case "coil-pro-tool/SET-COIL-TYPE": {
            if (action.coilType === state.coilType) {
                return state;
            }
            // The geometry, the air and the coefficients belong to the coil whatever runs through
            // it, so they survive the switch; the previous side's values go, and the new side starts
            // from its own defaults rather than from whatever the last side happened to leave behind.
            const kept = InitialValues.keepCommonOnly(state.pvses[0]);
            const pvs = applySweepDefaults(property_1.PropertyValueSet.merge(kept, InitialValues.sideDefaults(action.coilType)), action.coilType);
            return Object.assign(Object.assign({}, state), { coilType: action.coilType, pvses: [pvs], resultScreen: undefined });
        }
        case "coil-pro-tool/CALCULATE-COIL":
            return Object.assign(Object.assign({}, state), { resultScreen: action.payload });
        case "coil-pro-tool/SET-TOOL-MODE": {
            const offered = Types.coilTypesFor(action.mode);
            if (offered.indexOf(state.coilType) >= 0) {
                return Object.assign(Object.assign({}, state), { mode: action.mode });
            }
            // Express has no sweep for the coil type that was selected, so it falls back to the first
            // one the mode does offer rather than leaving a coil selected that cannot be calculated.
            const coilType = offered[0];
            return Object.assign(Object.assign({}, state), { mode: action.mode, coilType: coilType, pvses: [
                    applySweepDefaults(property_1.PropertyValueSet.merge(InitialValues.keepCommonOnly(state.pvses[0]), InitialValues.sideDefaults(coilType)), coilType)
                ], resultScreen: undefined });
        }
        case "popup-component/SET-PROPERTIES-COILPRO-DOWNLOAD-SELECTOR":
            return Object.assign(Object.assign({}, state), { popupDownloadSelector: action.payload });
        default:
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
            return state;
    }
}
/**
 * The indexed values an express run walks are generated from the min/max/step triples, and
 * which triples exist depends on the coil side - so which defaults to apply does too.
 *
 * They are generated whichever mode the tool is in. Doing it only in express mode meant that
 * picking a coil type while on the Calculate tab and then moving to Calculate coil Express
 * arrived at a set of stepped fields with no values in them: nothing regenerated on a mode
 * change. They cost nothing in the other modes, where no definition asks for them.
 */
function applySweepDefaults(pvs, coilType) {
    if (coilType === "steam") {
        let next = (0, functions_1.applySteamPressureDefaults)(pvs, true);
        next = (0, functions_1.applyInputTemperatureDefaults)(next, true);
        return (0, functions_1.applyInputHumidityDefaults)(next, true);
    }
    if (coilType === "fluid") {
        return (0, functions_1.applyFlowDefaults)((0, functions_1.applyTemperatureOutDefaults)(pvs, true), true);
    }
    // Express offers no DX or condenser sweep.
    return pvs;
}
function startingPvs(coilType) {
    return applySweepDefaults(applyCalculationOfCoildimensions(InitialValues.defaults(coilType)), coilType);
}
function applyCalculationOfCoildimensions(pvs) {
    const numberOfTubes = property_1.PropertyValueSet.getAmount("coiltubesinheight", pvs);
    const distBtwTubes = property_1.PropertyValueSet.getAmount("coildistbtwtubes", pvs);
    const coilHeight = uom_1.Amount.times(distBtwTubes, numberOfTubes);
    const coilWidth = property_1.PropertyValueSet.getAmount("coiltubelength", pvs);
    let newPvs = property_1.PropertyValueSet.merge(pvs, property_1.PropertyValueSet.Empty);
    newPvs = property_1.PropertyValueSet.setAmount("coilwidth", coilWidth, newPvs);
    newPvs = property_1.PropertyValueSet.setAmount("coilheight", coilHeight, newPvs);
    return newPvs;
}
function applyPassesOrCircuitsConsistency(pvs) {
    // Keep the hidden one updated.
    const nrTubesInHeight = property_1.PropertyValueSet.getAmount("coiltubesinheight", pvs);
    const rows = property_1.PropertyValueSet.getInteger("coilrows", pvs);
    const tubesPerRow = uom_1.Amount.times(nrTubesInHeight, rows);
    const isCircuits = property_1.PropertyValueSet.getInteger("coilcircuitsorpasses", pvs) === 1;
    if (isCircuits) {
        // Convert circuits to passes.
        const numCircuits = property_1.PropertyValueSet.getAmount("coilcircuits", pvs);
        const numPasses = uom_1.Amount.divide(tubesPerRow, numCircuits);
        return property_1.PropertyValueSet.setAmount("coilpasses", numPasses, pvs);
    }
    else {
        // Convert passes to circuits.
        const nrPasses = property_1.PropertyValueSet.getAmount("coilpasses", pvs);
        const numCircuits = uom_1.Amount.divide(tubesPerRow, nrPasses);
        return property_1.PropertyValueSet.setAmount("coilcircuits", numCircuits, pvs);
    }
}
function applyFinSpacingOrFinsPerInchConsistency(pvs) {
    const isFinSpacing = property_1.PropertyValueSet.getInteger("coilfinspacingorfinsperlength", pvs) ===
        1;
    if (isFinSpacing) {
        const finSpacing = property_1.PropertyValueSet.getAmount("coilfinspacing", pvs);
        const finsPerInch = uom_1.Amount.create(1 / uom_1.Amount.valueAs(uom_1.Units.Inch, finSpacing), uom_1.Units.One);
        return property_1.PropertyValueSet.setAmount("coilfinsperinch", finsPerInch, pvs);
    }
    else {
        const finsPerInch = property_1.PropertyValueSet.getAmount("coilfinsperinch", pvs);
        const finSpacing = uom_1.Amount.create(1 / uom_1.Amount.valueAs(uom_1.Units.One, finsPerInch), uom_1.Units.Inch);
        return property_1.PropertyValueSet.setAmount("coilfinspacing", finSpacing, pvs);
    }
}
//# sourceMappingURL=reducer.js.map